import React, { Fragment } from "react";
import { Route, Redirect } from "react-router-dom";

import PaymentsIndex from "pages/Payments/index";

import TermsConditionsIndex from "pages/TermsConditions/index";
import TermsConditionsStore from "pages/TermsConditions/store";

import BridgeTalkAdminIndex from "pages/BridgeTalkAdmin/index";
import BridgeTalkAdminStore from "pages/BridgeTalkAdmin/store";
import BridgeTalkAdminEdit from "pages/BridgeTalkAdmin/edit";

import EntityIndex from "pages/Entity/index";
import EntityEdit from "pages/Entity/edit";
import EntityShow from "pages/Entity/show";
import EntityStore from "pages/Entity/store";

import AccountSettingsIndex from "pages/AccountsSettings/index";
import ChangePassword from "pages/AccountsSettings/ChangePassword";

const AdminRoutes: React.FC = () => {
  return (
    <Fragment>
      {/* Entity | Start */}
      <Route exact path="/">
        <Redirect to="/entity-management" />
      </Route>
      <Route exact path="/entity-management" component={EntityIndex} />
      <Route exact path="/entity-management/create" component={EntityStore} />
      <Route
        exact
        path="/entity-management/:id/details"
        component={EntityShow}
      />
      <Route exact path="/entity-management/:id/edit" component={EntityEdit} />
      {/* Entity | End */}

      {/* Bridge Talk Admin | Start */}
      <Route exact path="/bridge-talk-admin" component={BridgeTalkAdminIndex} />
      <Route
        exact
        path="/bridge-talk-admin/create"
        component={BridgeTalkAdminStore}
      />
      <Route
        exact
        path="/bridge-talk-admin/:id/edit"
        component={BridgeTalkAdminEdit}
      />
      {/* Bridge Talk Admin | End */}

      <Route exact path="/payments" component={PaymentsIndex} />

      {/* Terms and Conditions | Start */}
      <Route exact path="/terms-conditions" component={TermsConditionsIndex} />
      <Route
        exact
        path="/terms-conditions/:id"
        component={TermsConditionsStore}
      />
      {/* Terms and Conditions | End */}

      {/* Account Settings | Start */}
      <Route exact path="/account-settings" component={AccountSettingsIndex} />
      <Route
        exact
        path="/account-settings/:id/change-password"
        component={ChangePassword}
      />
      {/* Account Settings | Start */}
    </Fragment>
  );
};

export default AdminRoutes;
